import { render } from "./drivers.vue?vue&type=template&id=dda8aa16&scoped=true"
import script from "./drivers.vue?vue&type=script&lang=js"
export * from "./drivers.vue?vue&type=script&lang=js"

import "./drivers.vue?vue&type=style&index=0&id=dda8aa16&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda8aa16"]])

export default __exports__